export default class Utils {
    static isRingSizeProduct() {
        return !!prestashop.modules.arkonringsizes.is_ring_size_product;
    }

    static showLoader() {
        $('.ars-form').prepend(
            '<div class="ars-loading-overlay loading-overlay"><div class="spinner"></div></div>'
        );
    }

    static hideLoader() {
        $('.ars-form').find('.ars-loading-overlay').remove();
    }
}
